import React from "react";
import { DownloadIcon, TrashIcon } from "./PrivacyIcons";

const PrivacyDataManagement = () => {
  return (
    <div className="v2-privacy-pg-card">
      <div className="v2-privacy-pg-card__header">
        <div className="v2-privacy-pg-card__icon-wrap" style={{ background: "#fef2f2" }}>
          <DownloadIcon size={20} color="#eb1414" />
        </div>
        <div>
          <h3 className="v2-privacy-pg-card__title">Data Management</h3>
          <p className="v2-privacy-pg-card__subtitle">
            Download or delete your account data
          </p>
        </div>
      </div>
      <div className="v2-privacy-pg-card__body">
        <div className="v2-privacy-pg-data-actions">
          <button className="v2-privacy-pg-btn-outline">
            <DownloadIcon size={16} color="#1a2233" />
            <span>Download My Data</span>
          </button>
          <button className="v2-privacy-pg-btn-danger">
            <TrashIcon size={16} color="#ffffff" />
            <span>Delete My Account</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyDataManagement;
